import { Button } from "@progress/kendo-react-buttons";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent, DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { defaultDate } from "../Common/Constants";
import Format from "../Common/Util_methods/formatParamOptions";
import { useAppDispatch } from "../Core/store.hooks";
import { getDevicesSelector } from "../Devices/Slice";
import { filterBy } from "@progress/kendo-data-query";
import { getOptionsSelector, updateMdcDrillDown, updateMdcGroupingOptions, updateMdcGroupSize } from "../Common/Slices/optionSlice";
import { mdcApi } from "./mdcApi";
import { addToMdcData, getMdcDataSelector, loadingMdcDataSelector, removeSeries, updateMdcData, updateSelectedSeries } from "./mdcSlice";
import {
    differenceBy, isEqual, orderBy, sortBy,
    isEmpty } from "lodash";
import useRemoveParams from '../Common/hooks/useRemoveParams';
import { useParams } from "react-router-dom";
import getQueryStringParams from "../Common/Util_methods/queryString";
import { Dialog } from "@progress/kendo-react-dialogs";
import GroupingOptions from "./GroupingOptions"; import {
    loginSelector,
    loadingLoginSelector,
    errorLoginSelector,
} from "../Core/Slice";

interface FilterProps {
    id:string;
    seriesFromGrid:any;
}

export interface Series{
    devicesWithSerial: string[];
    deviceTypes:number[];
    deviceName:string;
    deviceNameVersion:string;
    header:string;
}

export interface MachineHealthParams{
    start:string;
    end:string;
    bucketSize:"y" | "M" | "w" | "d";
    seriesObjects:Series[];
}

const initialSeries:Series = {
    devicesWithSerial:[],
    deviceTypes:[],
    deviceName:null,
    deviceNameVersion:null,
    header:null
}

const dataTypes = [
    "Total (Cumulative)",
    "Trend (None Cumulative)",
]
const seriesTypes: string[] = [
    "Device Name",
    "Device Name + Device Size + Version",
];

const Filters = (props: FilterProps) => {

    let startDate = new Date();
    startDate.setDate(startDate.getDate()-7);

    const { queryparams } = useParams();
    const [start, setStart] = useState(startDate);
    const [end, setEnd] = useState(new Date);

    //const interruptData = useSelector(getInterruptsSelector).interruptData
    const selectedSeries = useSelector(getMdcDataSelector).selectedSeries 
    const dispatch = useAppDispatch();

    const authResponse = useSelector(loginSelector);

    const [loggedIn, updateLoggedIn] = useState<boolean>(false);


    useEffect(() => {
        updateLoggedIn(authResponse);
    }, [authResponse]);



   
    

   

  
    const paramsHandler = () => {
        let params = {} as any
        params.start = formatDate(start);
        params.end = formatDate(end);
        params.seriesObjects = selectedSeries;
        dispatch(updateMdcData(params))
    };
 

    

   


    const formatDate = (d: any) => {
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;
        return year + "-" + month + "-" + day;
    };

    
    const renderDateInputs = () => {
        return (
            <Fragment>
                {" "}
                <div className="k-textbox-container metricCombo">
                    <label className="k-label">Start</label>
                    <DatePicker
                        value={start}
                        onChange={(e) =>
                            e.target.value && setStart(e.target.value)
                        }
                        format={"dd.MM.yyyy"}
                    />
                </div>
                <div className="k-textbox-container metricCombo">
                    <label className="k-label">End</label>
                    <DatePicker
                        value={end}
                        onChange={(e) =>
                            e.target.value && setEnd(e.target.value)
                        }
                        format={"dd.MM.yyyy"}
                    />
                </div>
            </Fragment>
        );
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    return (
        <Fragment>
            <div>
                {renderDateInputs()}
             
                <div>
                    <Button
                        className="pp-filter-button"
                        onClick={() => paramsHandler()}
                    >
                        UPDATE
                    </Button>
                </div>
            </div>
            <div className="pp-sidebar-header"> Add series </div>
            {/* <div className=" k-textbox-container metricCombo">
                <label className="k-label">Series Type</label>
                <DropDownList
                    popupSettings={{width:"auto"}}
                    data={seriesTypes}
                    value={seriesType}
                    onChange={seriesTypeHandler}
                />
            </div> */}

        </Fragment>
    );
};

export default Filters;
